import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css';
import PrimeVue from 'primevue/config'
import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core CSS
import "primeicons/primeicons.css"; //ico
import { createPinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import DialogService from 'primevue/dialogservice';
import 'primeicons/primeicons.css'
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';


const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
createApp(App).use(pinia).use(PrimeVue).use(router).use(DialogService).use(ConfirmationService).use(ToastService).directive('tooltip', Tooltip).mount('#app')
